import { useEffect } from "react";

// Per-route <title>, description, canonical and robots tags.
//
// This is a client-side SPA, so these are written into <head> after the bundle runs. Google
// renders JavaScript and will see them. Social scrapers (Discord, X, iMessage) do NOT — the
// og:* tags they read are the static ones in public/index.html, which describe the site as a
// whole. That split is deliberate: link unfurls are the same everywhere, search results are
// per page.

const ORIGIN = "https://flowtweaks.com";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * @param {object}  opts
 * @param {string} [opts.title]        Omit to leave document.title alone (StaffDashboard drives
 *                                     its own, with an unread count in front).
 * @param {string} [opts.description]
 * @param {string}  opts.path          Route path, e.g. "/referral".
 * @param {boolean}[opts.noindex]      Transactional or private routes.
 */
export function useSeo({ title, description, path, noindex = false }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    const url = `${ORIGIN}${path}`;
    upsertMeta("property", "og:url", url);
    upsertCanonical(url);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, noindex]);
}
